<template>
  <div class="container" >
    <transition name="fade">
      <div class="wh100" v-show="show">
        <div class="wh100" layout="row center-center">
          <img class="keyvisual" ref="image" src="/static/images/preloader-keyvisual.png" srcset="/static/images/preloader-keyvisual@2x.png 2x"/>
        </div>

      </div>
    </transition>


  </div>
</template>

<script>

  export default {
    components: {},
    name: "site-preloader",
    data() {
      return {
        show: false
      }
    },
    mounted() {
        this.$refs.image.onload = ()=>{
          this.show = true;
        };
    }
  }
</script>

<style scoped>
  .container {
    position: fixed;
    background-color: black;
    top:0;
    left:0;
    z-index:2000;
    width:100%;
    height:100%;

  }

  .keyvisual {
    width:70vw;
    max-width: 500px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SitePreloader.vue